import ProjectReducer from "./ProjectReducer";
import SystemReducer from "./SystemReducer";
import TaxonomyReducer from "./TaxonomyReducer";
import RecoReducer from "./RecoReducer";
import UserDetailsReducer from "./UserDetailsReducer";


export const Reducers = {
    userDetailsReducer:UserDetailsReducer,
    systemReducer:SystemReducer,
    taxonomyReducer:TaxonomyReducer,
    projectReducer:ProjectReducer,
    recoReducer:RecoReducer
}